import { Location } from 'history';

import { KeyMetricView } from './MerchantOverview.context';

const getHashFromProps = (location: Location) => {
  const hashOptions = [
    'Sales',
    'Transactions',
    'AOV',
    'Attribution',
    'Frequency',
  ];

  const hash = location.hash.substring(1) as KeyMetricView;

  if (hashOptions.includes(hash)) {
    return hash;
  }

  return 'Sales';
};

export { getHashFromProps };
